import React, { useContext } from 'react';
import { IconProps } from './iconProps';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';
import cx from 'classnames';

export default function IconRocket({
  onClick,
  isAutoscallable = true,
  sizeKey = '38x38',
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      className={cx('icon IconRocket', { 'icon-disabled': !onClick })}
      onClick={onClick}
      width={w}
      height={h}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40">
        <rect width="40" height="40" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_106_732)">
        <path
          d="M9.4165 16.7088L12.6665 18.0838C13.0554 17.306 13.4582 16.556 13.8748 15.8338C14.2915 15.1115 14.7498 14.3893 15.2498 13.6671L12.9165 13.2088L9.4165 16.7088ZM15.3332 20.1671L20.0832 24.8754C21.2498 24.431 22.4998 23.7504 23.8332 22.8338C25.1665 21.9171 26.4165 20.8754 27.5832 19.7088C29.5276 17.7643 31.0485 15.6046 32.1457 13.2296C33.2429 10.8546 33.7221 8.66709 33.5832 6.66709C31.5832 6.5282 29.3887 7.00736 26.9998 8.10459C24.6109 9.20181 22.4443 10.7226 20.4998 12.6671C19.3332 13.8338 18.2915 15.0838 17.3748 16.4171C16.4582 17.7504 15.7776 19.0004 15.3332 20.1671ZM22.7498 17.4588C22.1109 16.8199 21.7915 16.0351 21.7915 15.1046C21.7915 14.174 22.1109 13.3893 22.7498 12.7504C23.3887 12.1115 24.1804 11.7921 25.1248 11.7921C26.0693 11.7921 26.8609 12.1115 27.4998 12.7504C28.1387 13.3893 28.4582 14.174 28.4582 15.1046C28.4582 16.0351 28.1387 16.8199 27.4998 17.4588C26.8609 18.0976 26.0693 18.4171 25.1248 18.4171C24.1804 18.4171 23.3887 18.0976 22.7498 17.4588ZM23.5415 30.8338L27.0415 27.3338L26.5832 25.0004C25.8609 25.5004 25.1387 25.9518 24.4165 26.3546C23.6943 26.7574 22.9443 27.1532 22.1665 27.5421L23.5415 30.8338ZM36.5832 3.62542C37.1109 6.98653 36.7846 10.2574 35.604 13.4379C34.4234 16.6185 32.3887 19.6532 29.4998 22.5421L30.3332 26.6671C30.4443 27.2226 30.4165 27.7643 30.2498 28.2921C30.0832 28.8199 29.8054 29.2782 29.4165 29.6671L22.4165 36.6671L18.9165 28.4588L11.7915 21.3338L3.58317 17.8338L10.5415 10.8338C10.9304 10.4449 11.3957 10.1671 11.9373 10.0004C12.479 9.83375 13.0276 9.80598 13.5832 9.91709L17.7082 10.7504C20.5971 7.86153 23.6248 5.81986 26.7915 4.62542C29.9582 3.43098 33.2221 3.09764 36.5832 3.62542ZM6.5415 26.6254C7.51373 25.6532 8.70123 25.1601 10.104 25.1463C11.5068 25.1324 12.6943 25.6115 13.6665 26.5838C14.6387 27.556 15.1179 28.7435 15.104 30.1463C15.0901 31.549 14.5971 32.7365 13.6248 33.7088C12.9304 34.4032 11.7707 35.0004 10.1457 35.5004C8.52067 36.0004 6.27761 36.4449 3.4165 36.8338C3.80539 33.9726 4.24984 31.7296 4.74984 30.1046C5.24984 28.4796 5.84706 27.3199 6.5415 26.6254ZM8.9165 28.9588C8.63873 29.2365 8.36095 29.7435 8.08317 30.4796C7.80539 31.2157 7.61095 31.9588 7.49984 32.7088C8.24984 32.5976 8.99289 32.4101 9.729 32.1463C10.4651 31.8824 10.9721 31.6115 11.2498 31.3338C11.5832 31.0004 11.7637 30.5976 11.7915 30.1254C11.8193 29.6532 11.6665 29.2504 11.3332 28.9171C10.9998 28.5838 10.5971 28.424 10.1248 28.4379C9.65262 28.4518 9.24984 28.6254 8.9165 28.9588Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
